import React from 'react'
import { Carousel } from 'react-responsive-carousel'
import { useSubscribeAnalyticsEvent } from '@pff-consumer/feature-account/hooks/use-subscribe-analytics-event.web'

import { CarouselArrow } from '../../../common/carousel-arrow/carousel-arrow'
import { FeaturesCarouselProps } from './features-carousel.props'
import { FeatureCard } from '../feature-card/feature-card'
import { featureCardsObject } from './feature-cards-object'

export const FeaturesCarousel = (props: FeaturesCarouselProps) => {
  const { variant, carouselCards } = props
  const { sendSubscribeAnalyticsEvent } = useSubscribeAnalyticsEvent()

  let carouselProps = {
    centerSlidePercentage: 90,
    showArrows: false,
  }
  if (variant === 'desktop') {
    carouselProps = {
      centerSlidePercentage: 100,
      showArrows: true,
    }
  }

  const onCardChange = (index: number) => {
    sendSubscribeAnalyticsEvent('Card Swiped', {
      location: 'MDS Draft Result',
      variant: 'Upsell Modal - Variant 1',
      cardSwiped: index,
    })
  }

  return (
    <Carousel
      centerMode
      emulateTouch
      autoPlay={false}
      showStatus={false}
      showThumbs={false}
      showIndicators
      onChange={onCardChange}
      width='100%'
      {...carouselProps}
      renderArrowPrev={(onClickHandler: () => void, hasPrev: boolean, label: string) =>
        hasPrev && (
          <CarouselArrow
            onClickHandler={onClickHandler}
            label={label}
            isMdsCarousel
          />
        )
      }
      renderArrowNext={(onClickHandler: () => void, hasNext: boolean, label: string) =>
        hasNext && (
          <CarouselArrow
            onClickHandler={onClickHandler}
            label={label}
            isInverse
            isMdsCarousel
          />
        )
      }
    >
      {carouselCards?.map((card) => {
        return (
          <FeatureCard
            key={card}
            imagePath={`/assets/images/${card}-card.webp`}
            imageAltText={featureCardsObject[card].imageAltText}
            title={featureCardsObject[card].title}
            subTitle={featureCardsObject[card].subTitle}
            featurePoints={featureCardsObject[card].featurePoints}
          />
        )
      })}
    </Carousel>
  )
}
